import { render, staticRenderFns } from "./PersonnelAuditAndtrainigTables.vue?vue&type=template&id=64c284d6"
import script from "./PersonnelAuditAndtrainigTables.vue?vue&type=script&lang=js"
export * from "./PersonnelAuditAndtrainigTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports